export default "__VITE_ASSET__tqxSSSmb__"